import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";


@Component({
  selector: 'app-entrada',
  templateUrl: './entrada.component.html',
  styleUrls: ['./entrada.component.css']
})
export class EntradaComponent implements OnInit {

  @Input() parentForm:FormGroup;
  @Input() nombreControl:string;
  @Input() configCampo;
  @Input() valor;
  etiqueta;
  nombreCampo;
  control = new FormControl("", [Validators.required]);

  constructor(private global:Globals) { }

  ngOnInit() {
    if(this.valor){
      this.control.setValue(this.valor);
    }
    this.parentForm.addControl(this.nombreControl,this.control);
    if(this.global.lenguaje=="es"){
      this.etiqueta = this.configCampo.es;
      this.nombreCampo = this.configCampo.es;
    }else{
      this.etiqueta = this.configCampo.en;
      this.nombreCampo = this.configCampo.en;
    }

    
  }

}
